"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zeroRightClassName = 'right-scroll-bar-position';
exports.fullWidthClassName = 'width-before-scroll-bar';
exports.noScrollbarsClassName = 'with-scroll-bars-hidden';
exports.removedBarSizeVariable = '--removed-body-scroll-bar-size';
